// miniapp/src/client/super/SuperAdminHome.tsx  (обновлённый — добавлена кнопка "Уведомления")
import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { ROUTE } from "../lib/paths";
import { can, type Role, normalizeRole } from "../lib/roles";

export default function SuperAdminHome() {
  const [role, setRole] = useState<Role>(null);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const me = await api.me();
        if (!alive) return;
        setRole(normalizeRole(me.role));
      } catch {
        setRole(null);
      }
    })();
    return () => {
      alive = false;
    };
  }, []);

  const goScan = () => ROUTE.go(ROUTE.scan());

  return (
    <div className="relative z-10 mx-auto max-w-[720px]">
      <div className="ui-card p-6 sm:p-8">
        <header className="flex items-start justify-between gap-3">
          <div>
            <h1 className="text-[32px] leading-[1.05] font-extrabold tracking-tight">
              Панель · <span className="text-white/90">{(role || "guest").toUpperCase()}</span>
            </h1>
            <p className="mt-2 text-sm text-neutral-300">Управление мероприятием и быстрая навигация.</p>
          </div>
          <span className="ui-chip shrink-0">
            v1.0 (role-aware)
          </span>
        </header>

        {/* Быстрые действия */}
        <div className="mt-6 grid gap-3">
          {can(role, "scan_qr") && (
            <button
              onClick={goScan}
              className="ui-btn-lg w-full"
            >
              Сканировать QR
            </button>
          )}
        </div>

        {/* Мероприятия */}
        {can(role, "manage_events") && (
          <section className="mt-6 grid gap-4">
            <Panel title="Мероприятие">
              <div className="grid gap-2 sm:grid-cols-2">
                <Btn label="Создать мероприятие" onClick={() => ROUTE.go(ROUTE.eventNew())} />
                <Btn label="Все мероприятия" onClick={() => ROUTE.go(ROUTE.events())} />
              </div>
            </Panel>
          </section>
        )}

        {/* Персонал */}
        {can(role, "manage_staff") && (
          <section className="mt-6 grid gap-4">
            <Panel title="Персонал (только SUPERADMIN)">
              <div className="grid gap-2 sm:grid-cols-2">
                <Btn label="Состав стаффа" onClick={() => ROUTE.go(ROUTE.staff())} />
              </div>
            </Panel>
          </section>
        )}

        {can(role, "messages") && (
          <section className="mt-6 grid gap-4">
            <Panel title="Коммуникации">
              <div className="grid gap-2 sm:grid-cols-2">
                <Btn label="Сообщения" onClick={() => ROUTE.go(ROUTE.messages())} />
                <Btn label="Промокоды" onClick={() => ROUTE.go(ROUTE.promo())} />
              </div>
            </Panel>
          </section>
        )}

        {can(role, "manage_settings") && (
          <section className="mt-6 grid gap-4">
            <Panel title="Настройки (owner)">
              <div className="grid gap-2 sm:grid-cols-2">
                <Btn label="Общие настройки" onClick={() => ROUTE.go(ROUTE.settings())} />
              </div>
            </Panel>
          </section>
        )}
      </div>
    </div>
  );
}

function Panel({
  title,
  children,
  tone,
}: {
  title: string;
  children: React.ReactNode;
  tone?: "danger" | "default";
}) {
  const border = tone === "danger" ? "border-red-500/30" : "border-white/10";
  const bg = tone === "danger" ? "bg-red-500/10" : "bg-white/5";
  return (
    <div className={`ui-panel ${border} ${bg}`}>
      <div className="mb-3 text-sm text-neutral-300">{title}</div>
      {children}
    </div>
  );
}

function Btn({ label, onClick }: { label: string; onClick: () => void }) {
  return (
    <button
      onClick={onClick}
      className="ui-btn w-full text-sm font-medium"
    >
      {label}
    </button>
  );
}
